import io from 'socket.io-client';
import { Scheduler } from '@reactivex/rxjs';
import { Model } from '@graphistry/falcor-model-rxjs';
import { LocalDataSink, RemoteDataSource, whitelistClientAPIRoutes } from './falcor';
import { createLogger } from '@graphistry/common/logger';

const logger = createLogger(__filename);

function congfigureLive(options) {

    //TODO bring back once new logging strategy
    /*
    if (window.graphistryClientId) {
        const splunkSearch = `search (host=staging* OR host=labs*) (level=60 OR level=50 OR level=40) source="/var/log/graphistry-json/*.log" metadata.userInfo.cid="${window.graphistryClientId}"`;
        const params = { q: splunkSearch, 'display.page.search.mode': 'verbose', earliest: '', latest: '' };
        const paramString = Object.entries(params).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');
        console.debug(`Access splunk logs for this session at https://splunk.graphistry.com:3000/en-US/app/search/search?${paramString}`);
    }
    */

    const session = options.session;
    const model = (window.appModel = new Model({
        recycleJSON: true,
        scheduler: Scheduler.async,
        allowFromWhenceYouCame: true,
        cache: window.__INITIAL_CACHE__ // eslint-disable-line no-underscore-dangle
    }));
    logger.debug({__INITIAL_CACHE__}, '__INITIAL_CACHE__');

    const timeoutS = process.env.NODE_ENV !== 'production' ? 86400 : 120;  // default ping: 25s

    const mgrOpts = {
        reconnection: true,
        perMessageDeflate: false,
        timeout: timeoutS * 1000,
        reconnectionDelay: 10 * 1000,
        reconnectionDelayMax: 10 * 1000,
        ...(!process.env.STUB_DEPENDENCIES ? {path: '/graph/socket.io'} : {}),
        transports: ['websocket', 'polling'],
        query: {clientId: window.graphistryClientId, ...options}
    };
    const sockURI = window.graphistryPath || location.origin;
    //console.info({sockURI, mgrOpts}, `Connecting socket: ${sockURI}`);
    const socket = io(sockURI, mgrOpts);
    //console.debug('continuing after app server connect call (may not be connected yet)')

    socket.on('trail', (trail) => {
        window.trail = trail;
    });
    socket.binaryType = 'arraybuffer';
    socket.io.engine.binaryType = 'arraybuffer';
    model._source = new RemoteDataSource(socket, model);
    model.sink = new LocalDataSink( __INITIAL_CACHE__.flags, whitelistClientAPIRoutes(model));

    const socketIoEmit = socket.emit;
    socket.emit = function emitWithoutCompression() {
        return socketIoEmit.apply(this.compress(false), arguments);
    };

    return { ...options, model, socket, session };
}

export { congfigureLive };
export default congfigureLive;
